
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/art-for-impact-campaign",
      function () {
        return require("private-next-pages/art-for-impact-campaign/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/art-for-impact-campaign"])
      });
    }
  